export enum AnnouncementLSKey {
  ANNOUNCEMENT_POPUP_STATE = "APS",
  NOT_NOW = "NN",
  FINISH = "FNS",
}
